// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3crTQ","left":"StickyBox_left__1mzyx","right":"StickyBox_right__1cGXq"};